import {
  SubscriptionStatus,
  WorkspacePlan,
} from '@up2stay/up2promo-api-client';

export type SidebarUpgradeTeaserVariant =
  | 'trialStart'
  | 'trialActive'
  | 'upgrade';

export type SidebarUpgradeTeaserVariantInput = {
  plan: WorkspacePlan;
  status: SubscriptionStatus | undefined;
};

/**
 * Picks sidebar teaser copy: promote starting/continuing a trial when that
 * path is still open; otherwise urge upgrade to Plus / Teams.
 *
 * - `trialActive` — currently trialing
 * - `trialStart` — Free without a payment-problem status (checkout still
 *   attaches trial days when configured)
 * - `upgrade` — unpaid / past_due / canceled / incomplete / etc.
 */
export function resolveSidebarUpgradeTeaserVariant(
  input: SidebarUpgradeTeaserVariantInput,
): SidebarUpgradeTeaserVariant {
  if (input.status === SubscriptionStatus.TRIALING) {
    return 'trialActive';
  }

  if (input.plan === WorkspacePlan.FREE) {
    const paymentProblem =
      input.status === SubscriptionStatus.UNPAID ||
      input.status === SubscriptionStatus.PAST_DUE ||
      input.status === SubscriptionStatus.CANCELED ||
      input.status === SubscriptionStatus.INCOMPLETE ||
      input.status === SubscriptionStatus.INCOMPLETE_EXPIRED ||
      input.status === SubscriptionStatus.PAUSED;

    if (!paymentProblem) {
      return 'trialStart';
    }
  }

  return 'upgrade';
}
